import type { SVGProps } from 'react';

const SvgEditOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m21.41 6.33-3.75-3.75-2.53 2.54 3.75 3.75zM1.39 4.22l7.32 7.32L3 17.25V21h3.75l5.71-5.71 7.32 7.32 1.41-1.41L2.81 2.81zm16.42 5.72-3.75-3.75-2.52 2.52 3.75 3.75z" />
  </svg>
);
export default SvgEditOff;
